import React, { useEffect } from 'react'

const HtmlRawContainer = ({ containerObject, templateName, contentId, dataZone }) => {

useEffect(()=>{
  var hash = window.location.hash;
  if (hash) {
    var element = document.querySelector(hash);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  }
},[])
  
  return (

    <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content row g-0 cb-html-content px-3 ${containerObject?.enableContentVisibilityAttribute === "Y" ?  containerObject?.attributes?.enableContentVisibility === "N" ? "" : 'content-visibility-class':''}`} dangerouslySetInnerHTML={{ __html: containerObject && containerObject.attributes && containerObject.attributes.htmlRawContent  ? containerObject.attributes.htmlRawContent : "" }}  >
      {/* {containerObject && containerObject.attributes && containerObject.attributes.htmlRawContent ? <div dangerouslySetInnerHTML={{ __html: containerObject.attributes.htmlRawContent }}></div> : ""} */}
    </div>

  )
}

export default HtmlRawContainer